import { ContractDocumentsFormData } from '../../../types';

export const contractDocsInitialState = {
	accountId: null,
	commencementDate: null,
	contractDate: null,
	contractType: null,
	documentPath: null,
	documentContentType: null,
	expirationDate: null,
	landlordEntity: null,
	parkingContractSection: null,
	subscriberEntity: null,
	subscriberType: null,
};

export const requiredFields = {
	accountId: 'Account ID',
	subscriberType: 'Subscriber Type',
	contractType: 'Contract Type',
	contractDate: 'Contract Date',
};

const dateFields = ['contractDate', 'commencementDate', 'expirationDate'];

// Could get this from an enum but that could cause issues
// if the enum isn't supposed to show up in the ui
export const subscriberType = [
	'TENANT',
	'NON_TENANT_OFFICE',
	'NON_TENANT_RETAIL',
	'NON_TENANT_HOTEL',
	'VALET_COMPANY',
	'RENTAL_CAR_COMPANY',
	'MUNICIPALITY',
	'CONSTRUCTION_COMPANY',
	'CRUISE_SHIP',
	'OTHER',
];

export const contractType = [
	'AMENDMENT',
	'EASEMENT',
	'LEASE',
	'LETTER_AGREEMENT',
	'LICENSE_AGREEMENT',
	'OTHER',
	'SUBTENANT_AGREEMENT',
	'VALIDATION_AGREEMENT',
];

export const getMissingFields = (formData: ContractDocumentsFormData) =>
	Object.keys(requiredFields).reduce((acc, curr) => {
		const hasValue = !!formData[curr];
		if (!hasValue) {
			return [...acc, requiredFields[curr]];
		}
		return acc;
	}, []);

export const getFieldsToEdit = (formData: ContractDocumentsFormData) =>
	Object.keys(contractDocsInitialState).reduce((acc, key) => {
		// Converting these since datagrid needs a date object but date picker needs a string
		const isDateField = dateFields.includes(key);
		if (isDateField) {
			return {
				...acc,
				[key]: formData[key] ? formData[key].split('T')[0] : null,
			};
		}
		return {
			...acc,
			id: formData.id,
			[key]: formData[key] || null,
		};
	}, {} as ContractDocumentsFormData);
